"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = synchronizeTableTRSizes;

function synchronizeHeaderSizesBetweenTables(fromTable, toTable) {
  var fromTableRows = fromTable.querySelectorAll('tbody tr');
  var toTableRows = toTable.querySelectorAll('tbody tr');
  fromTableRows.forEach(function (fromTableRow, i) {
    return toTableRows[i] && (toTableRows[i].style.height = "".concat(fromTableRow.getBoundingClientRect().height, "px"));
  });
}

function synchronizeTableHeaderSizes(headers) {
  var syncFunc = function syncFunc() {
    var maxHeight = 0;
    headers.forEach(function (item) {
      if (item.getBoundingClientRect().height > maxHeight) {
        maxHeight = item.getBoundingClientRect().height;
      }
    });
    headers.forEach(function (item) {
      var trElems = item.querySelectorAll('tr');

      if (trElems.length === 1) {
        trElems[0].style.height = "".concat(maxHeight, "px");
      }
    });
  };

  syncFunc();
}

var synchronize = function synchronize(node) {
  var mainTable = node.querySelector('.table-main');
  var fixedLeftTable = node.querySelector('.table-left');
  var fixedRightTable = node.querySelector('.table-right');
  var fixedHeaders = document.querySelectorAll('.table-header-fixed');
  var tableHeaders = document.querySelectorAll('.table-header thead');

  if (fixedLeftTable) {
    synchronizeHeaderSizesBetweenTables(mainTable, fixedLeftTable);
  }

  if (fixedRightTable) {
    synchronizeHeaderSizesBetweenTables(mainTable, fixedRightTable);
  }

  if (fixedHeaders) {
    synchronizeTableHeaderSizes(fixedHeaders);
  }

  if (tableHeaders) {
    synchronizeTableHeaderSizes(tableHeaders);
  }
};

function synchronizeTableTRSizes(node) {
  // for initial render
  setTimeout(function () {
    synchronize(node);
  }, 300); // when the fonts are loaded properly

  setTimeout(function () {
    synchronize(node);
  }, 2000);
}